import dateUtil from './dateUtil';

const isValidDateTime = (dateTime: string, format: string): boolean => dateUtil(dateTime, format).isValid();

export default isValidDateTime;
